import * as React from 'react';
import './WakeUp.css';

const WakeUp = (props) => {

    function padTo2Digits(num) {
        return String(num).padStart(2, '0');
    }

    function addMinutes(numOfMinutes, date = new Date()) {
        const dateCopy = new Date(date.getTime());

        dateCopy.setTime(dateCopy.getTime() + numOfMinutes * 60 * 1000);

        return dateCopy;
    }

    const date = new Date();

    const result1 = addMinutes(3*90+15, date);
    const display1 = result1.getHours() + 'H' + padTo2Digits(result1.getMinutes());
    const result2 = addMinutes(4*90+15, date);
    const display2 = result2.getHours() + 'H' + padTo2Digits(result2.getMinutes());
    const result3 = addMinutes(5*90+15, date);
    const display3 = result3.getHours() + 'H' + padTo2Digits(result3.getMinutes());
    const result4 = addMinutes(6*90+15, date);
    const display4 = result4.getHours() + 'H' + padTo2Digits(result4.getMinutes());

    return (
        <div>
            <div id={'banner'}>
                <div id={'arrow'} onClick={() => props.navigate(0)}>
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M16.2426 6.34317L14.8284 4.92896L7.75739 12L14.8285 19.0711L16.2427 17.6569L10.5858 12L16.2426 6.34317Z"
                            fill="#EDA1AB"
                        />
                    </svg>
                </div>
                <span>Heures de réveil</span>
            </div>
            <div id={'wakeUpContainer'}>
                <div className={'wakeUpCard'}>
                    <div className={'wakeUpCardHeader'}>
                        --
                    </div>
                    <div className={'wakeUpCardHeaderText'}>
                        <span>{display1}</span>
                        <span>3 cycles (4H30)</span>
                    </div>
                </div>
                <div className={'wakeUpCard'}>
                    <div className={'wakeUpCardHeader'}>
                        -
                    </div>
                    <div className={'wakeUpCardHeaderText'}>
                        <span>{display2}</span>
                        <span>4 cycles (6H)</span>
                    </div>
                </div>
                <div className={'wakeUpCard'}>
                    <div className={'wakeUpCardHeader'}>
                        +
                    </div>
                    <div className={'wakeUpCardHeaderText'}>
                        <span>{display3}</span>
                        <span>5 cycles (7H30)</span>
                    </div>
                </div>
                <div className={'wakeUpCard'}>
                    <div className={'wakeUpCardHeader'}>
                        ++
                    </div>
                    <div className={'wakeUpCardHeaderText'}>
                        <span>{display4}</span>
                        <span>6 cycles (9H)</span>
                    </div>
                </div>
            </div>

        </div>

    );
};

export default WakeUp;